import {ErrorFilter} from './error-filter';

export class ErrorListRequest {
  botId: number;
  search: string;
  limit: number;
  offset: number;
  sortProp: string;
  sortDir: string;
  filter: ErrorFilter;

  constructor(botId: number, search: string, limit: number,
              offset: number, sortProp: string, sortDir: string, filter: ErrorFilter) {
    this.botId = botId;
    this.search = search;
    this.limit = limit;
    this.offset = offset;
    this.sortProp = sortProp;
    this.sortDir = sortDir;
    this.filter = filter;
  }
}
